class Kereso {
    constructor() {

        this.$searchInput = null;
        this.$searchButton = null;
        this.searchPageUrl = '';
        this.$resultsPanel = null;
        this.$widthRef = null;
        this.isMobile = false;

        this.changeBaseParent();

        $(window).on('resize', () => {
            this.changeBaseParent();
        });

        $('body').on('click', (e) => {
            if ($(e.target).closest('.search-results-panel').length === 0) {
                $('.search-results-panel').addClass('d-none').empty();
                this.updateMenuZIndex();
                if ($(window).width() < 992 && $('.mobile-header-right .search-panel-kont').hasClass('d-none')) {
                    $('header.main-line').removeClass('d-none');
                }
            }
        });

    }

    changeBaseParent() {
        this.isMobile = $(window).width() < 992;

        if (this.isMobile) {
            this.$searchInput = $('.mobile-header-right .search-panel-kont .search-panel input');
            this.$searchButton = $('.mobile-header-right .search-panel-kont .search-panel a.search');
            this.searchPageUrl = $('.mobile-header-right .search-panel-kont .search-panel').data('search-url');
            this.$resultsPanel = $('.mobile-header-right .search-panel-kont .search-results-panel');
            this.$widthRef = $('.mobile-header-right .search-panel-kont .container .col');
        } else {
            var $header = $('header').filter(function() {
                return $(this).find('.top-right-items .search-panel').length > 0 &&
                       $(this).find('.search-results-panel').length > 0;
            }).first();

            if (!$header.length) {
                $header = $('header .search-panel').first().closest('header');
            }

            if ($header.length) {
                this.$searchInput = $header.find('.top-right-items .search-panel input');
                this.$searchButton = $header.find('.top-right-items .search-panel a.search');
                this.searchPageUrl = $header.find('.top-right-items .search-panel').data('search-url');
                this.$resultsPanel = $header.find('.search-results-panel').not('.search-panel-kont .search-results-panel').first();
                this.$widthRef = $header.find('.top-right-items');
            }
        }

        if (this.$searchInput && this.$searchInput.length) {
            this.initEvents();
            this.positionResults();
        }
    }

    updateMenuZIndex() {
        if (this.$resultsPanel && !this.$resultsPanel.hasClass('d-none') && this.$resultsPanel.is(':visible')) {
            $('header.termekmenu-kont').css('z-index', 100);
        } else {
            $('header.termekmenu-kont').css('z-index', 150);
        }
    }

    positionResults() {
        var $panel = this.$resultsPanel;
        if (!$panel || !$panel.length) return;

        var $searchPanel = this.$searchInput.closest('.search-panel');

        if (!this.isMobile) {
            var searchPanelRight = $searchPanel.offset().left + $searchPanel.outerWidth();
            $panel.css('left', '');
            $panel.css('right', ($(window).width() - searchPanelRight) + 'px');
        } else {
            $panel.css('left', $searchPanel.offset().left + 'px');
            $panel.css('right', '');
        }
        $panel.css('top', $searchPanel.offset().top + $searchPanel.outerHeight() + 'px');
        $panel.css('width', this.$widthRef.outerWidth() + 'px');
    }

    initEvents() {

        if (!this.$searchInput.data('initialized')) {
            this.$searchInput.on('keyup', (e) => {

                if ($(window).width() < 992) {
                    $('header.main-line').addClass('d-none');
                }

                if (this.$searchInput.val().length > 2) {
                    if (e.key === 'Enter') {
                        window.location.href = this.searchPageUrl + '?q=' + this.$searchInput.val();
                    }

                    this.search(this.$searchInput.val());
                } else {
                    this.$resultsPanel.addClass('d-none').empty();
                    this.updateMenuZIndex();
                }

            });
            this.$searchInput.data('initialized', true);
        }

        if (!this.$searchButton.data('initialized')) {
            this.$searchButton.on('click', (e) => {
                e.preventDefault();
                window.location.href = this.searchPageUrl + '?q=' + this.$searchInput.val();
            });
            this.$searchButton.data('initialized', true);
        }

        if (!$('.mobile-header-right .search-button').data('initialized')) {

            $('.mobile-header-right .search-button').on('click', (e) => {
                e.preventDefault();
                $('.mobile-header-right .search-panel-kont').removeClass('d-none');
                $('header.main-line').addClass('d-none');
            });
            $('.mobile-header-right .search-button').data('initialized', true);
        }

        if (!$('.mobile-header-right .search-panel .close-me').data('initialized')) {
            $('.mobile-header-right .search-panel .close-me').on('click', (e) => {
                e.preventDefault();
                $('header.main-line').removeClass('d-none');
                $('.mobile-header-right .search-panel-kont').addClass('d-none');
                $('.mobile-header-right .search-panel-kont input').val('');
                $('.mobile-header-right .search-panel-kont .search-results-panel').empty().addClass('d-none');
            });
            $('.mobile-header-right .search-panel .close-me').data('initialized', true);
        }
    }


    search(query) {
        var searchResult = this.$resultsPanel;

        var $searchPanel = this.$searchInput.closest('.search-panel');

        if (!this.isMobile) {
            var searchPanelRight = $searchPanel.offset().left + $searchPanel.outerWidth();
            searchResult.css('left', '');
            searchResult.css('right', ($(window).width() - searchPanelRight) + 'px');
        } else {
            searchResult.css('left', $searchPanel.offset().left + 'px');
            searchResult.css('right', '');
        }
        searchResult.css('top', $searchPanel.offset().top + $searchPanel.outerHeight() + 'px');
        searchResult.css('width', this.$widthRef.outerWidth() + 'px');

        searchResult.removeClass('d-none');
        searchResult.addClass('waiting');
        this.updateMenuZIndex();
        if ($(window).width() < 992) {
            $('header.main-line').addClass('d-none');
        } else {
            $('header.main-line').removeClass('d-none');
        }

        if (window.keresoCSRFToken !== undefined) {
            $.ajaxSetup({
                headers: {
                    'X-CSRF-Token': window.keresoCSRFToken
                }
            });
        }
        $.get('/cimlapkereso/suggest', {
            q: query,
            r: new Date().getTime()
        }, (data) => {
            searchResult.removeClass('waiting');
            if (!data) {
                searchResult.addClass('d-none').empty();
                this.updateMenuZIndex();
                if ($(window).width() < 992) {
                    $('header.main-line').removeClass('d-none');
                }
                return;
            }
            if (data === 'empty') {
                searchResult.addClass('d-none').empty();
                this.updateMenuZIndex();
                if ($(window).width() < 992) {
                    $('header.main-line').removeClass('d-none');
                }
                return;
            }

            searchResult.html(data);
            this.updateMenuZIndex();
        }, 'html');

    }

}

export default Kereso;
